import { CellContentType } from '../../../../shared/components/table/models/cellContent.model';
import { TableHeaders } from '../../../../shared/components/table/models/tableHeaders.model';

export const ConfigurationTypeTableHeaders: TableHeaders[] = [
  {
    key: 'name',
    label: 'TYPE',
    content: {
      maxLength: 20,
      type: CellContentType.Text
    }
  },
  {
    key: 'id',
    label: 'ABBR',
    content: {
      maxLength: 10,
      type: CellContentType.Text
    },
    disabledCondition: ({ newItem }) => !newItem
  },
  {
    key: 'save',
    label: '',
    disabledCondition: ({ name, id }) => !name?.length || !id?.length,
    content: {
      type: CellContentType.Button,
      label: 'Save'
    }
  },
  {
    key: 'active',
    label: ' ',
    content: {
      type: CellContentType.Switcher
    }
  }
];
